import { css } from "@emotion/core";

export const horizontalScrollContainer = css`
  display: flex;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  padding-top: 20px;

  @media (min-width: 768px) {
    flex-wrap: wrap;
    overflow-x: auto;
    margin-bottom: -25px;
  }
`;

export const checkContainer = css`
  position: relative;
  margin-right: 25px;
  background: #fff;

  @media (min-width: 768px) {
    margin-bottom: 25px;
  }
`;

export const checkContainer2 = css`
  position: relative;
  margin-right: 25px;
  background: #fff;
`;

export const hasPriceContainer = css`
  @media (min-width: 768px) {
    margin-bottom: 25px;
  }
`;

export const longLabel = css`
  @media (min-width: 576px) {
    label {
      font-size: 12px;
    }
  }

  @media (min-width: 768px) {
    label {
      font-size: 16px;
    }
  }
`;

export const selectWithMinWidth = css`
  min-width: 200px;
`;
